<template>
	<!-- 技能配置弹窗：新增/编辑技能 -->
	<el-dialog :title="title" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
		<el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
			<!-- 技能名称 -->
			<el-form-item label="技能名称" prop="skillName">
				<el-input v-model="form.skillName" placeholder="请输入技能名称" />
			</el-form-item>
			<!-- 技能编码 -->
			<el-form-item label="技能编码" prop="skillCode">
				<el-input v-model="form.skillCode" placeholder="请输入技能编码" />
			</el-form-item>
			<!-- 排序值 -->
			<el-form-item label="排序值" prop="sort">
				<el-input-number v-model="form.sort" placeholder="请输入排序值" :min="1" :max="9999" :step="1"></el-input-number>
			</el-form-item>
			<!-- 通信箱转发 -->
			<el-form-item label="通信箱转发">
				<el-checkbox v-model="transferFlag" />
			</el-form-item>
			<!-- 终端显示 -->
			<el-form-item label="终端显示">
				<el-checkbox v-model="mobileShowFlag" />
			</el-form-item>
		</el-form>

		<!-- 弹窗底部按钮 -->
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose" :disabled="submitLoading">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
/**
 * 技能配置弹窗组件
 * 功能：新增/编辑项目技能
 * 特性：表单验证、防重复提交
 */
import { debounce } from "@/utils/debounce";
import { courseSkillAdd, courseSkillUpdate } from "@/api/skill";

export default {
	name: "SkillConfigDialog",

	data() {
		return {
			dialogVisible: false, // 弹窗显示状态
			title: "项目技能新增", // 弹窗标题
			transferFlag: false, // 通信箱转发复选框状态
			submitLoading: false, // 提交按钮loading，防止重复提交
			mobileShowFlag: false, // 终端显示复选框状态
			form: {
				id: "", // 技能ID（编辑时有值）
				skillName: "", // 技能名称
				skillCode: "", // 技能编码
				sort: 1, // 排序值
				transferFlag: "", // 通信箱转发（0/1）
				mobileShowFlag: "", // 终端显示（0/1）
			},
			// 表单验证规则
			rules: {
				skillName: [{ required: true, message: "请输入技能名称", trigger: "blur" }],
				skillCode: [{ required: true, message: "请输入技能编码", trigger: "blur" }],
			},
		};
	},

	methods: {
		/**
		 * 初始化弹窗
		 * @param {Object} dt - 编辑数据（空表示新增模式，有值表示编辑模式）
		 */
		init(dt) {
			this.dialogVisible = true;
			// 重置表单数据
			this.resetForm();
			this.title = "项目技能新增";

			// 编辑模式：填充已有数据
			if (dt) {
				this.title = "项目技能编辑";
				this.form.id = dt.id;
				this.form.skillName = dt.skillName;
				this.form.skillCode = dt.skillCode;
				this.form.sort = dt.sort;
				this.form.transferFlag = dt.transferFlag;
				this.transferFlag = dt.transferFlag === 1;
				this.form.mobileShowFlag = dt.mobileShowFlag;
				this.mobileShowFlag = dt.mobileShowFlag === 1;
			}
		},

		/**
		 * 重置表单数据
		 */
		resetForm() {
			this.form = {
				id: "",
				skillName: "",
				skillCode: "",
				transferFlag: "",
				mobileShowFlag: "",
				sort: 1,
			};
			this.transferFlag = false;
			this.mobileShowFlag = false;
			this.submitLoading = false;
			// 清空表单验证状态
			this.$nextTick(() => {
				this.$refs.form && this.$refs.form.clearValidate();
			});
		},

		/**
		 * 关闭弹窗
		 */
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},

		/**
		 * 提交表单
		 * 根据是否有id判断是新增还是编辑
		 * 使用debounce防抖，防止重复提交
		 */
		handleSubmit: debounce(function () {
			if (this.submitLoading) return;
			// 表单验证
			this.$refs.form.validate((valid) => {
				if (!valid) return;

				// 转换通信箱转发值为数字
				this.form.transferFlag = this.transferFlag ? 1 : 0;
				this.form.mobileShowFlag = this.mobileShowFlag ? 1 : 0;

				// 根据是否有id判断编辑/新增模式
				const apiMethod = this.form.id ? courseSkillUpdate : courseSkillAdd;
				const successMsg = this.form.id ? "编辑成功" : "新增成功";

				// 开启提交loading
				this.handleClose();
				apiMethod(this.form)
					.then(() => {
						this.$message.success(successMsg);

						this.$emit("getSkillList");
					})
					.finally(() => {
						this.submitLoading = false;
					});
			});
		}, 300),
	},
};
</script>

<style scoped></style>
